import type { ModuleManifest } from "./manifest-registry";
import type { SlotId } from "./slot-id.type";

/** The ids of everything any module contributes to a slot, whether its module is on or not: a host uses it to tell an address that is hidden (answer "not found") from one that never existed. */
export function contributedIds(manifests: readonly ModuleManifest[], slotId: SlotId): string[] {
  return manifests.flatMap((m) => m.contributes.filter((c) => c.slot === slotId).map((c) => c.id));
}
